import Vue from 'vue'
import Router from 'vue-router'
import LayOut from '@/view/LayOut'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: LayOut,
      children: [
        {
          path: '/',
          name: 'Introduce',
          component: () => import('@/view/introduce')
        },
        {
          path: '/shiguangshu',
          name: 'Shiguangshu',
          component: () => import('@/view/shiguangshu')
        },
        {
          path: '/shiguangshuweb',
          name: 'Shiguangshuweb',
          component: () => import('@/view/shiguangshuweb')
        },
        {
          path: '/logo',
          name: 'Logo',
          component: () => import('@/view/logo')
        },
        {
          path: '/hongpa',
          name: 'Hongpa',
          component: () => import('@/view/hongpa')
        },
        {
          path: '/h5',
          name: 'H5',
          component: () => import('@/view/H5')
        },
        {
          path: '/book',
          name: 'Book',
          component: () => import('@/view/book')
        },
        {
          path: '/haiplus',
          name: 'Haiplus',
          component: () => import('@/view/haiplus')
        },
        {
          path: '/chahua',
          name: 'Chahua',
          component: () => import('@/view/chahua')
        }
      ]
    },
    {
      path: '/404',
      name: 'Page404',
      component: () => import('@/view/404/index')
    },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js